/**
 * Autonomy Level options for the Business Goals step (Figma 3926-9563).
 *
 * Stored on the usecase as `autonomy_level` (1–4). Level 1 is a classic
 * (non-agentic) model; any other level makes the task agentic, which adds
 * the Agent Config wizard step and the trajectory mapping in Data Collection.
 */
export const AUTONOMY_LEVEL_NO_TOOL_CALLING = 1;
export const AUTONOMY_LEVEL_ONE_PREDETERMINED_TOOL_CALL = 2;
export const AUTONOMY_LEVEL_AGENT_DECIDES_TOOLS = 3;
export const AUTONOMY_LEVEL_OPEN_ENDED = 4;

export const AUTONOMY_LEVEL_OPTIONS = [
    { value: AUTONOMY_LEVEL_NO_TOOL_CALLING, label: 'Model has no tool calling (not agentic)' },
    {
        value: AUTONOMY_LEVEL_ONE_PREDETERMINED_TOOL_CALL,
        label: 'Agent has one predetermined tool call per intent',
    },
    { value: AUTONOMY_LEVEL_AGENT_DECIDES_TOOLS, label: 'Agent decides which tools to call to' },
    { value: AUTONOMY_LEVEL_OPEN_ENDED, label: 'Agent can explore, goal can be open-ended' },
];

export const AUTONOMY_LEVEL_HELP =
    'How much freedom the trained agent has: from a plain model with no tool calling, ' +
    'through one predetermined tool call per intent, to an agent that decides which tools ' +
    'to call or explores open-ended goals.';

export const autonomyLevelLabel = (level) =>
    AUTONOMY_LEVEL_OPTIONS.find((o) => o.value === Number(level))?.label ?? '';

/** Normalizes an API / form value to a valid level, or `null` when unset. */
export const normalizeAutonomyLevel = (raw) => {
    if (raw === null || raw === undefined || raw === '') return null;
    const level = Number(raw);
    return AUTONOMY_LEVEL_OPTIONS.some((o) => o.value === level) ? level : null;
};

/** Agentic iff a level is set and is not "no tool calling". */
export const isAgenticAutonomyLevel = (level) => {
    const normalized = normalizeAutonomyLevel(level);
    return normalized !== null && normalized !== AUTONOMY_LEVEL_NO_TOOL_CALLING;
};
